module.exports = [{
    value: 'zh-cn',
    label: '中文字体',
    children: [{
            value: 'chuantong',
            label: '传统经典',
            children: [{
                    value: "simhei",
                    label: "黑体(默认)"
                },
                {
                    value: "xkjt",
                    label: "行楷简体"
                },
                {
                    value: "fzzyjt",
                    label: "稚艺简体"
                },
                {
                    value: "hwls",
                    label: "华文隶书"
                },
                {
                    value: "hycxjt",
                    label: "汉仪程行简体"
                },
                {
                    value: "hyswss",
                    label: "汉仪尚魏手书"
                },
                {
                    value: "fzljd",
                    label: "方正吕建德字体简"
                },


            ]
        },
        {
            value: 'wenyi',
            label: '文艺清雅',
            children: [{
                    value: "nssj",
                    label: "南宋书局"
                },
                {
                    value: "wyjt",
                    label: "夜未央"
                }, {
                    value: "ssrj",
                    label: "秘密日记"
                },
                {
                    value: "xhjn",
                    label: "杏花江南"
                },
                {
                    value: "pfzl",
                    label: "平凡之路"
                }, {
                    value: "wtxy",
                    label: "梧桐细雨"
                },
                {
                    value: "mmxj",
                    label: "默陌信笺"
                },
            ]
        }, {
            value: 'gufeng',
            label: '毛笔古风',
            children: [{
                    value: "dnmbxsxdb",
                    label: "段宁毛笔"
                },
                {
                    value: "dfp",
                    label: "东风破"
                },
                {
                    value: "cmys",
                    label: "草木一生"
                },
                {
                    value: "bxgh",
                    label: "八仙过海"
                },
                {
                    value: "hjsd",
                    label: "黄金时代"
                },


            ]
        }, {
            value: 'kawayii',
            label: '卡哇萌系',
            children: [{
                    value: "hdmxj",
                    label: "蝴蝶喵小姐"
                },
                {
                    value: "mdtkzc",
                    label: "猫的天空之城"
                },
                {
                    value: "lyy",
                    label: "乐悠悠"
                },
                {
                    value: "hksn",
                    label: "华康少女"
                },
                {
                    value: "tmxns",
                    label: "甜蜜小女生"
                },
                {
                    value: "yqmm",
                    label: "元气满满"
                },
                {
                    value: "mtr",
                    label: "木头人"
                },

            ]
        },
    ]
}, {
    value: 'en',
    label: '英文字体',
    children: [{

        value: 'alsmyxj',
        label: '爱丽丝梦游仙境'
    }, {
        value: 'aqkxq',
        label: '爱情狂想曲'
    }, {
        value: 'ckxt',
        label: '刺客信条'
    }, {
        value: 'tlms',
        label: '提拉米苏'
    }, {
        value: 'ctsdm',
        label: '窗台上的猫'
    }]

}]


// WEBPACK FOOTER //
// ./src/store/fontOptions.js